export { AtnDsSearchComponent as Component } from './search.component'
export * as models from './models'
